import React, { useState, useEffect } from 'react';
import { Bubble } from 'tea-component';
import {
  getHomeRecommendations,
  fetchClickHomeRecommendations,
  fetchClickClosedHomeRecommendations,
  operationLog,
} from '@/pages/home/services/home';
import { isEmpty } from '@/pages/intelligence/utils/commonUtils';
import moment from 'moment';
import { useIntl, getLocale, history } from 'umi';
import { LANGUAGE_EN } from '@/pages/home/_config/config';
import { buriedBtnPoint } from '@home/utils/buriedPoint';

export default function RecommendedPosition() {
  const [recommendations, setRecommendations] = useState<any>({});
  const PCTYPE = 'pc';
  const MOMENTFORMAT = 'YYYY-MM-DD hh:mm:ss';
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const isEn = locale === LANGUAGE_EN;
  /**获取标题跳转的URL */
  const fetchRecommendData = async () => {
    const params = {
      entity_type: PCTYPE,
      date: moment().format(MOMENTFORMAT),
    }
    try {
      const dataRes = await getHomeRecommendations(params);
      setRecommendations(dataRes || {});
    } catch (err) {
    }
  };


  /**当前用户点击推荐信息,点击推荐卡片打点 */
  const handleClickOperationLog = async () => {
    const paramsObj = {
      buttonId: '100101011',
      extInfo: JSON.stringify({
        recommend_id: recommendations.id,
        recommend_image: recommendations.display_image,
        recommend_theme_cn: recommendations.title_cn,
        recommend_theme_en: recommendations.title_en,
        recommend_redirect_url: recommendations.redirect_url,
      }),
      pageId: '100101',
      typeId: 'homePage_pc_v2'
    }
    const { buttonId, extInfo, pageId, typeId = 'dashboard_pc_v2' } = paramsObj;
    const params = {
      logType: 'buttonLog',
      openId: '',
      buttonLog: {
        source: 1,
        typeId,
        buttonId,
        extInfo,
        pageId,
      }
    };
    // 有正确跳转信息，跳转
    if (recommendations?.redirect_url) {
      if (recommendations?.redirect_url.includes('common-digital-large-screen')) {
        window.open(recommendations?.redirect_url);
        return;
      }
      history.push(recommendations?.redirect_url);
    }
    // 已写打点，此接口不再调用
    await operationLog(params).then(() => {
      //   handleClickRecommendations();
    }).catch((e) => { console.log(e) });
  }

  /**当前用户点击推荐信息 */
  const handleClickRecommendations = async () => {
    const params = {
      entity_type: PCTYPE,
      recommendation_id: recommendations.id
    }
    try {
      const dataRes = await fetchClickHomeRecommendations(params);
    } catch (err) {
    }
  };

  /**当前用户点击关闭推荐信息 */
  const handleClickClose = async () => {
    const params = {
      entity_type: PCTYPE,
      recommendation_id: recommendations.id
    }
    try {
      const dataRes = await fetchClickClosedHomeRecommendations(params);
      fetchRecommendData();
    } catch (err) {
    }
  };

  useEffect(() => {
    // 首次进入，查询推荐卡片内容
    fetchRecommendData();
  }, []);

  return (
    <>
      {
        isEmpty(recommendations) ? null : <div
          className="dbh-recommended-position"
          style={{
            backgroundImage:
              `url(${recommendations.display_image})`,
          }}
          onClick={() => {
            handleClickOperationLog()
          }}
        >
          <Bubble
            placement="top-end"
            dark
            content={formatMessage({ id: `dbh_recommendation_nolonger_displayed` })}
            placementOffset={[16, 30]}
            className="dbh-recommended-position-bubble"
          >
            <div
              className="recommended-position-close"
              onClick={(e) => {
                e.stopPropagation();
                handleClickClose();
              }}
            ></div>
          </Bubble>
          <div className="recommended-position-info">
            <i className="recommended-position-icon"></i>
            <div className="recommended-position-text">
              {isEn ? recommendations.title_en : recommendations.title_cn}
            </div>
          </div>
        </div>
      }
    </>
  );
}
